import i18n from "i18next";
import AddOns from "@/Pages/BuyFlow/AddOns";

export default function ChooseAddOns({state, dispatch}) {
    return <div>
            <div className="d-flex justify-content-between header">
                <span className="titles">
                    <span className="step">{i18n.t('buy-flow.step-two')}</span>
                    <span className="step-title">{i18n.t('buy-flow.choose-add-ons')}</span>
                    <span className="step-subtitle">{i18n.t('buy-flow.choose-add-ons-header')} <a className='step-link' href="https://www.ministrybrands.com/customer-success-services/" target="_blank">{i18n.t('buy-flow.choose-add-on-link')}</a></span>
                    <span className="step font-14 mt-2">{i18n.t('buy-flow.choose-add-on-text')}</span>
                </span>
            </div>
            <div className="add-on-scroll">
                <div className="step-container">
                    <AddOns state={state} dispatch={dispatch} />
                </div>
            </div>
           </div>
}
